import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { makeStyles } from "@material-ui/core";
import Loader from "../components/Atoms/Loader";

const TOKEN_KEY = process.env.REACT_APP_TOKEN_KEY;

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const OAuth = (props) => {
  let classes = useStyles();
  let query = useQuery();

  useEffect(() => {
    const token = query.get("access-token");

    if (token) {
      localStorage.setItem(TOKEN_KEY, token);
      props.history.push("/employers");
    }
  }, [query, props.history]);

  return (
    <div className={`${classes.container} s-cross-center s-main-center`}>
      <Loader />
    </div>
  );
};

const useStyles = makeStyles((theme) => ({
  container: {
    height: "100vh",
  },
}));

export default OAuth;
